import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NGXLogger } from 'ngx-logger';
import { tap } from 'rxjs/operators';
import { Api } from 'src/app/shared/constants/api';
import { PermissionKey } from 'src/app/shared/constants/permissionCode';
import { IPermissionWithShow } from 'src/app/shared/interface';
import { DataService } from 'src/app/shared/services/data.service';
import { PermissionService } from 'src/app/shared/services/permissions.service';
import { UtilityService } from 'src/app/shared/services/utility.service';
import { ICharge, IChargeCriteria } from '../charge.interface';
import * as _ from 'underscore';
import { ActivatedRoute, Router } from '@angular/router';
import { Message } from 'src/app/shared/constants/message';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-charge-list',
    templateUrl: './charge-list.component.html',
    styleUrls: ['./charge-list.component.less'],
    standalone: false
})
export class ChargeListComponent implements OnInit, AfterViewInit, OnDestroy {

  constructor(private utilityService:UtilityService,private formBuilder:FormBuilder,
    private dailog:MatDialog,private permissionService:PermissionService,
    private service:DataService,private logger:NGXLogger, private router:Router,
    private activatedRoute: ActivatedRoute) { }


viewPermission : boolean = false;
addPermission : boolean = false;
editPermission : boolean = false;
totalRecords:any;
pageSizeOptions=this.utilityService.getPageSizeOptions();
chargeColumns=['name','code','type','unitType','chargeCategory','status','action'];
statusTypes=[];
chargeTypes=[];
chargeListForm:FormGroup;
chargeDataSource=new MatTableDataSource<ICharge>();
criteria:IChargeCriteria={};
@ViewChild(MatPaginator) paginator: MatPaginator;
@ViewChild(MatSort) sort: MatSort;
subscription = new Subscription();

ngOnInit(): void {
  this.getAllPermissions();
  this.initializeForm();
  this.setNameValueChangeEvent();
  this.setCodeValueChangeEvent();
  this.setStatusValueChangeEvent();
  this.setTypeValueChangeEvent(); 
  this.getStatusTypes();
  this.getChargeTypes();
}

private initializeForm(): void {
  this.chargeListForm=this.formBuilder.group({
    id:[],
    code:[],
    name:[],
    type:[],
    status:[]
  })
}

sortData(event: { active: string; direction: string; }){
  this.criteria.sort = [event.active, event.direction];
  this.getChargeList(true);
}

ngAfterViewInit(){
  this.chargeDataSource.sort=this.sort;
  this.chargeDataSource.paginator=this.paginator;
  this.paginator.page.pipe(tap(() => this.getChargeList())).subscribe();
  this.getChargeList();
}

ngOnDestroy(): void {
  this.subscription.unsubscribe();
}

openForm(id?: any): void {
  if(id){
    this.editPermission ? this.router.navigate(['edit/'+id],{relativeTo:this.activatedRoute}):
        this.utilityService.notifier(Message.EDIT_PERMISSION_WARNING,"warning");
  } else {
    this.addPermission ? this.router.navigate(['add'],{relativeTo:this.activatedRoute}) : 
        this.utilityService.notifier(Message.ADD_PERMISSION_WARNING,"warning");
  }
}

private setNameValueChangeEvent() {
  this.subscription = this.name.valueChanges.subscribe(nameValue => {
    this.criteria['name.contains']=nameValue;
    this.getChargeList(true);
  });
}

private setCodeValueChangeEvent(){
  const sub = this.code.valueChanges.subscribe(codeValue => {
    this.criteria['code.contains']=codeValue;
    this.getChargeList(true);
  });
  this.subscription.add(sub);
}

private setStatusValueChangeEvent(){
  const sub = this.status.valueChanges.subscribe(statusValue => {
    this.criteria.status=statusValue;
    this.getChargeList(true);
  });
  this.subscription.add(sub);
}

private setTypeValueChangeEvent(){
  const sub = this.type.valueChanges.subscribe(typeValue => {
    this.criteria.type=typeValue;
    this.getChargeList(true);
  });
  this.subscription.add(sub);
}

private getChargeList(resetPageIndex: boolean =false){
  if (resetPageIndex) {
    this.paginator.pageIndex = 0;
  }
  this.criteria.size=this.paginator.pageSize;
  this.criteria.page=this.paginator.pageIndex;
  if(this.viewPermission){
    this.service.get(Api.CHARGE,this.criteria).subscribe(res => {
      if(res){
        if(res.contents.length==0){
          this.utilityService.notifier('No Records Found','info');
        }
        this.logger.info("Charge List",res.contents);
        this.chargeDataSource=res.contents;
        this.totalRecords=res.totalRecords;
        if (this.paginator.pageIndex >= Math.ceil(this.totalRecords / this.paginator.pageSize)) {
          this.paginator.pageIndex = 0;
        }
      }
   }); 
  } else
      this.utilityService.notifier(Message.VIEW_PERMISSION_WARNING,"warning");
}

private getStatusTypes(){
  this.service.get(Api.STATUS_TYPE_LIST).subscribe(res => {
    this.statusTypes.push({key: "", label: "Search by Status"});
    this.statusTypes.push(...res);
  });
}

private getChargeTypes(){
  this.service.get(Api.CHARGE_TYPES).subscribe(res => {
    this.chargeTypes.push({key: "", label: "Search by Charge"});
    this.chargeTypes.push(...res);
  });
}

public getAllPermissions(){
  const permissionCodes=[PermissionKey.CHARGE_ADD_PERMISSION,PermissionKey.CHARGE_EDIT_PERMISSION,PermissionKey.CHARGE_VIEW_PERMISSION];
  const permissionsWithShowValue:IPermissionWithShow[]=this.permissionService.checkPermissions(permissionCodes,PermissionKey.CHARGE);
  this.addPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.CHARGE_ADD_PERMISSION})?.show?true:false;
  this.viewPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.CHARGE_VIEW_PERMISSION})?.show?true:false; 
  this.editPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.CHARGE_EDIT_PERMISSION})?.show?true:false; 
}

  get code(){ return this.chargeListForm.get('code'); }
  get name(){ return this.chargeListForm.get('name'); }
  get id(){ return this.chargeListForm.get('id'); }
  get status(){ return this.chargeListForm.get('status'); }
  get type(){ return this.chargeListForm.get('type'); }
}
